import Joi from "joi";

const campoValido = (nombre, formState, schema) => {
    const fieldToValidate = { [nombre]: formState[nombre] };
    const fieldSchema = Joi.object({ [nombre]: schema.extract(nombre) });
    const result = fieldSchema.validate(fieldToValidate);
    if (result.error)
        return result.error;
}

export const getHintsForField = (fieldName, errors, variant = "error") => {
    const errorObject = errors.find((error) => error[fieldName]);
    return errorObject ? [{ variant, text: errorObject[fieldName], },] : [];
};

export const datosValidos = (nc, formState, schema, idfiles3) => {
    const camposValidar = ['tipoComprobanteSelected', 'conceptoDelGastoSelected', 'razonSocial', 'cuit', 'fecha', 'importe', 'motivoGasto']
    let invalido = !nc.cuitValido
    for (let campo of camposValidar) {
        if (campoValido(campo, formState, schema))
            invalido = true
    }
    invalido = invalido ? true : (nc.archivoComprobante.current.value == '' && !idfiles3);
    if (!invalido && !nc.otroComprobante) {
        invalido = !nc.tipoCaeCai;
        if (!invalido && !nc.sinCaeCai)
            invalido = campoValido('caeCai', formState, schema);
        if (!invalido) {
            invalido =
                campoValido('puntoVenta', formState, schema) ||
                campoValido('numeroComprobante', formState, schema);
        }
    }
    return !invalido;
}